module.exports = __webpack_public_path__ + "img/ic_send.72e18b07.svg";